import React from 'react'
import styled from 'styled-components'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {getFormattedYearMonth} from '../../common/NatDateFormatted'

interface Props {
    title: string,
    yearMonth?: string,
    amount?: string,
    displayValue?: string,
    isAdminUser: boolean
}

const NatResidentBillingDetailItem: React.FC<Props> = props => {
    return <DetailRow>
        <TitleColumn>{props.title}</TitleColumn>
        {props.yearMonth &&
            <YearMonthColumn>{props.isAdminUser
                ? props.yearMonth
                : getFormattedYearMonth(props.yearMonth)}分</YearMonthColumn>
        }
        {props.amount &&
            <BoldColumn $widthFixed={true}>{props.isAdminUser
                ? props.amount
                : Number(props.amount).toLocaleString()}円</BoldColumn>
        }
        {props.displayValue &&
            <BoldColumn>{props.displayValue}</BoldColumn>
        }
    </DetailRow>
}

NatResidentBillingDetailItem.displayName = 'NatResidentBillingDetailItem'
export default NatResidentBillingDetailItem

const DetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid ${Colors.AccentLight};
    gap: 10px;
`

const TitleColumn = styled.div`
    flex: 0 0 134px;
    font-size: ${FontSize.Middle};
    white-space: pre-wrap;
`

const YearMonthColumn = styled.div`
    font-size: ${FontSize.Small};
    color: ${Colors.AccentDark};
    text-align: center;
`

const BoldColumn = styled.div<{ $widthFixed?: boolean }>`
    flex: ${({$widthFixed}) => ($widthFixed ? '0 0 80px' : '1')};
    word-break: break-word;
    font-size: ${FontSize.Body};
    text-align: right;
    font-weight: bold;
`